import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found — Mobile Specialist", description: "The page you're looking for doesn't exist.", path: "/404" });
  return (
    <div className="container-wide flex min-h-[60vh] flex-col items-center justify-center py-20 text-center" data-testid="not-found">
      <p className="font-display text-8xl font-extrabold accent-text">404</p>
      <h1 className="mt-4 font-display text-3xl font-bold">Page not found</h1>
      <p className="mt-2 max-w-md text-[hsl(var(--ink-soft))]">This page may have moved. Let's get you back to finding phones or booking a repair.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-ink">Back Home</Link>
        <Link to="/phones" className="btn-outline">Browse Phones</Link>
      </div>
    </div>
  );
}
